export default "__VITE_ASSET__e78afb2c__"